import { LogOut } from 'lucide-react';
import { Link, useRouter } from '../lib/router.jsx';
import { navFor } from '../lib/nav.js';
import { useSession, initialsOf } from '../lib/session.jsx';
import { api } from '../lib/api.js';

export default function Sidebar({ unheardCount = 0 }) {
  const session = useSession();
  const { path } = useRouter();
  const items = navFor(session.role);

  // Clearing the cookie is the backend's job — a full reload afterwards, not a
  // client-side route change, so nothing scoped stays in memory.
  const signOut = async () => {
    try {
      await api.post('/session/logout');
    } finally {
      window.location.href = '/';
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        {/* The name is part of the artwork, so it isn't set in text beside it —
            two sources for one word is how they end up disagreeing.

            Served at 3x the slot it occupies, so it stays sharp on a retina
            display; the width is set in CSS and the height follows. */}
        <img
          src="/logo.png"
          alt="vSwitch.uk"
          className="sidebar__logo"
          width="576"
          height="114"
        />
      </div>

      <nav className="sidebar__nav" aria-label="Portal sections">
        {items.map((n) => {
          const Icon = n.icon;
          const active = path === n.path;
          return (
            <Link
              key={n.id}
              to={n.path}
              className={`navitem${active ? ' navitem--active' : ''}`}
              aria-current={active ? 'page' : undefined}
              style={{ textDecoration: 'none' }}
            >
              <Icon size={17} />
              {n.label}
              {n.id === 'voicemail' && unheardCount > 0 && (
                <span className="navitem__badge">{unheardCount}</span>
              )}
            </Link>
          );
        })}
      </nav>

      <div className="sidebar__foot">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 4px' }}>
          <div className="avatar">{initialsOf(session.company)}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            {/* The customer's trading name from WHMCS. The PBX tenant slug is
                still in the session payload for support and the console, but
                it is an internal identifier and no customer calls themselves
                "houseofflagsltd". */}
            <div
              className="sidebar__who"
              style={{ fontSize: 13, fontWeight: 600 }}
              title={session.company}
            >
              {session.company}
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--ink-soft)' }}>
              Customer ID #{session.clientId}
            </div>
          </div>
          <button
            type="button"
            onClick={signOut}
            aria-label="Sign out"
            title="Sign out"
            style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}
          >
            <LogOut size={16} color="var(--ink-soft)" />
          </button>
        </div>
      </div>
    </aside>
  );
}
